import { CanActivateFn, Router } from '@angular/router';
import { AuthTokenService } from '../auth/auth-token.service';
import { inject } from '@angular/core';
import { AlertService } from '../common-services/alert.service';
import { AuthService } from '../auth/auth.service';
import { LoggerService } from '../shared/logger.service';
import { of } from 'rxjs';

export const isLoggedInGuard: CanActivateFn = async (route, state) => {
  let loggedIn = inject(AuthTokenService).isLoggedIn;
  let logger = inject(LoggerService);
  let router = inject(Router);
  logger.debug('isLoggedInGuard...', loggedIn, route, state);
  if (!loggedIn) {
    // redirect to login page.
    let authService = inject(AuthService);
    return authService.checkRefreshToken()
      .then(secondIsLoggedIn => {
        logger.debug(`isLoggedInGuard:secondIsLoggedIn:`, secondIsLoggedIn);
        if (!secondIsLoggedIn) {
          logger.error('isLoggedInGuard...redirect to login...');
          inject(AlertService).openSnackBar('Must be logged in to access this service');
          router.navigate(['login'], { queryParams: { returnUrl: state.url } });
        }
        return secondIsLoggedIn;
      })
      .catch(err => {
        logger.error('isLoggedInGuard...redirect to login...');
        inject(AlertService).openSnackBar('Must be logged in to access this service');
        router.navigate(['login'], { queryParams: { returnUrl: state.url } });
        return false;
      });
    // console.log('isLoggedInGuard...redirect to login...');
    // inject(AlertService).openSnackBar('Must be logged in to access this service');
    // inject(Router).navigate(['login'], {queryParams: {returnUrl: state.url}});
  } else {
    return Promise.resolve(loggedIn);
  }
  // return loggedIn;
};
